import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { TophatSnippet } from "@foundation/nextjs-tophat";

const initialState: TophatSnippet["snippet"] = {
    that: "",
    scripts: [],
    styles: [],
    styles_overrides: "",
};

const tophatSlice = createSlice({
    name: "tophatSnippet",
    initialState,
    reducers: {
        tophatSnippetsFetched(
            state,
            action: PayloadAction<TophatSnippet["snippet"]>
        ) {
            Object.assign(state, action.payload);
        },
    },
});

export const { tophatSnippetsFetched } = tophatSlice.actions;

export default tophatSlice.reducer;
